import type { Directive } from "vue";
import { stopEnterPropagation } from "@/utils/form-keyboard";

/**
 * Prevents accidental form submission when Enter is pressed inside a multiline field.
 * The default newline behavior is preserved.
 */
export const noEnterSubmit: Directive<HTMLElement, void> = {
    mounted(el) {
        el.addEventListener("keydown", stopEnterPropagation);
    },
    unmounted(el) {
        el.removeEventListener("keydown", stopEnterPropagation);
    },
};
